<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="saveLoading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary">
                Edit Base Dues
            </h2>
            <div class="pb-0">
                <v-form name="editForm" ref="editForm">
                    <div class="tw-flex tw-mb-2 tw-p-2">
                        <div class="tw-flex tw-flex-col tw-w-full">
                            <v-text-field
                                v-model="baseDuesValue"
                                label="Value"
                                :rules="[rules.currency]"
                                outlined
                                type="number"
                                dense
                                clearable
                            ></v-text-field>
                        </div>
                    </div>
                </v-form>
            </div>

            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3" >
                <v-btn
                    text
                    @click="cancelDialog"
                    class="main-btn"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="saveModel"
                    class="main-btn"
                    :loading="saveLoading"
                >
                    Save
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>

export default {
    name: "EditBaseDuesDialog",
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'baseDues': {
            type: String,
            required: false,
            default: function () {
                return ''
            }
        }
    },
    updated() {
        //
    },
    data() {
        return {
            dialog: this.value || false,
            errors: null,
            saveLoading: false,
            archiveLoading: false,
            rules: {
                currency: value => /^\d+(\.\d?\d)?$/.test(value) || `Number only.`,
            },
            baseDuesValue: '',
        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '550px'
        },
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        resetValidation () {
            if (this.$refs && this.$refs.editForm) {
                this.$refs.editForm.resetValidation()
            }
            this.errors = null
        },
        saveModel() {
            let payload = {
                name: this.constants.SETTINGS.SETTING_BASE_DUES,
                value: this.baseDuesValue,
            }

            if (!this.$refs.editForm.validate()) {
                this.$root.snackbar.error('Please fill all required fields.')
                return false
            }

            let url = route('setting.set', this.constants.SETTINGS.SETTING_BASE_DUES)

            axios({
                method: 'post',
                url: url,
                data: payload,
                onUploadProgress: (evt) => {
                    this.saveLoading = !this.saveLoading
                },
                onDownloadProgress: (evt) => {
                    this.saveLoading = !this.saveLoading
                },
            })
                .then(response => {
                    if (response.data.success) {
                        this.$root.is_dirty = false
                        this.$root.snackbar.success('Changes have been saved')
                        this.dialog = false
                        this.$root.is_dirty = false
                        this.saveLoading = false
                        this.$emit('successful-save', response.data.data.value)
                    } else if (response.data?.error) {
                        throw (response.data?.error)
                    } else {
                        throw ('Unknown error.')
                    }
                })
                .catch((error) => {
                    if( error?.response ) {
                        this.$root.snackbar.error(error.response.data.message)
                        this.errors = error.response?.data?.errors
                    } else {
                        console.log(error)
                        this.$root.snackbar.error(error)
                    }
                    this.saveLoading = false
                })
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
                this.resetValidation()
            } else {
                // Opening modal
                this.resetValidation()
                if (this.baseDues !== null) {
                    this.mode = 'Edit'
                    this.$set (this, 'baseDuesValue', JSON.parse(JSON.stringify(this.baseDues)))
                }
            }
        },
        modelObject: {
            handler(newVal, oldVal) {
                this.resetValidation()
            },
            deep: true,
        },
    },
}

</script>

<style scoped>

</style>
